import {
  successAction,
  GET_EXTRA_CHANNEL,
  GET_EXTRA_CLASS_TAG,
  GET_EXTRA_TEACH_TAG,
  GET_EXTRA_TYPE_TAG,
} from '../types';

const initialState = {
  extraChannel: [],
  extraClassTags: [],
  extraTechTags: [],
  extraTypeTags: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case successAction(GET_EXTRA_CHANNEL): {
      return {
        ...state,
        extraChannel: action.payload,
      };
    }
    case successAction(GET_EXTRA_CLASS_TAG): {
      return {
        ...state,
        extraClassTags: action.payload,
      };
    }
    case successAction(GET_EXTRA_TEACH_TAG): {
      return {
        ...state,
        extraTechTags: action.payload,
      };
    }
    case successAction(GET_EXTRA_TYPE_TAG): {
      return {
        ...state,
        extraTypeTags: action.payload,
      };
    }
    default:
      return state;
  }
};
